import * as React from 'react';
const SvgCheckCircleFill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M12 3a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3m3.64 7.77-3.5 3.51c-.4.4-.59.6-.82.67-.2.07-.42.07-.62 0-.23-.07-.43-.27-.82-.67l-1.52-1.52a4 4 0 0 1-.22-.23.6.6 0 0 1-.12-.18C8 12.3 8 12.24 8 12.19s0-.1.02-.15c.04-.11.14-.21.33-.41l.28-.28c.2-.2.3-.3.41-.33.1-.03.21-.03.31 0 .05.02.09.04.14.08.07.06.15.14.27.25l1.25 1.24 3.22-3.22c.2-.2.3-.3.41-.33.02 0 .05-.01.07-.02.08-.01.16 0 .23.02.11.04.21.14.41.33l.28.28c.2.2.3.3.33.41.03.1.03.21 0 .31-.04.11-.14.21-.33.41z"
    />
  </svg>
);
export default SvgCheckCircleFill;
